import React, { useEffect, useState } from 'react';

import TradingViewTickers from './TradingViewTickers';

function Header() {
  const [dateTime, setDateTime] = useState('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const time = now.toLocaleTimeString();
      const date = now.toLocaleDateString(undefined, options);
      setDateTime(`${date} | ${time}`);
    };

    const interval = setInterval(updateDateTime, 1000);
    updateDateTime();
    return () => clearInterval(interval);
  }, []);

  return (
    <header>
      <div className="logo">Crawford Family Bank</div>
      <TradingViewTickers />
      <div className="datetime">{dateTime}</div>
    </header>
  );
}

export default Header;